var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content operationRobot" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.addRobotShow = true
                  }
                }
              },
              [_vm._v("新增机器人")]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: { "background-color": "#fff", "margin-top": "6px" }
          },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", prop: "sorting", width: "50" }
                }),
                _c("el-table-column", {
                  attrs: { label: "机器人名称", prop: "taskName" }
                }),
                _c("el-table-column", {
                  attrs: { label: "机器人属性", prop: "robotAttribute" }
                }),
                _c("el-table-column", {
                  attrs: { label: "机器人状态" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: [
                                scope.row.taskStatus === 1
                                  ? "setColorBlue"
                                  : "setColorGray"
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.taskStatus(scope.row.taskStatus))
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { fixed: "right", label: "操作", width: "300" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.runImmediately(scope.row)
                                }
                              }
                            },
                            [_vm._v("立即运行")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.operationPlan(scope.row)
                                }
                              }
                            },
                            [_vm._v("运行计划")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addRobotShow,
            title: "新增机器人",
            width: "360px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addRobotShow = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-checkbox-group",
                {
                  staticClass: "add-robot",
                  on: {
                    change: function($event) {
                      return _vm.statusChange()
                    }
                  },
                  model: {
                    value: _vm.checkList,
                    callback: function($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList"
                  }
                },
                _vm._l(_vm.robotList, function(item) {
                  return _c("el-checkbox", {
                    key: item.uuid,
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: { label: item.taskName, value: item.uuid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addRobotFunc } },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ]
      ),
      _c("plan-dialog", {
        ref: "planDialog",
        attrs: { "dialog-form": _vm.dialogForm, "robot-list": _vm.robotList },
        on: { planCancel: _vm.planCancel, nextStep: _vm.nextStep }
      }),
      _c("configuration-dialog", {
        ref: "configurationDialog",
        attrs: { "configuration-form": _vm.configurationForm },
        on: {
          configurationCancel: _vm.configurationCancel,
          runCreate: _vm.runCreate,
          lastStep: _vm.lastStep,
          createPlan: _vm.createPlan
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }